import React from "react";
import Navbar from "@/components/Navbar";
import { VISIBLE_EVENT_CATEGORIES } from "@/config/eventCategories";

const CATEGORIES = VISIBLE_EVENT_CATEGORIES;

const About = ({ user, onLogout }) => {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-white" data-testid="about-page">
      <Navbar user={user} onLogout={onLogout} />

      {/* Hero */}
      <div className="relative overflow-hidden">
        <div
          className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[520px]"
          style={{ background: "radial-gradient(ellipse at center, rgba(37,99,235,.25), transparent 68%)" }}
        />
        <div className="max-w-4xl mx-auto px-6 pt-32 pb-10 relative">
          <span className="inline-block text-blue-400 text-xs font-semibold tracking-[0.14em] uppercase mb-4">
            No Fan Left Behind
          </span>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight mb-6">
            About ShowMeLive
          </h1>
          <p className="text-gray-300 text-lg leading-relaxed">
            ShowMeLive is a next-generation live streaming platform that bridges the
            gap between in-person experiences and global accessibility. By combining
            high-quality, low-latency streaming with interactive features, fan
            monetization tools, and creator-first economics, we enable fans to
            experience live faith and community events from anywhere in the world.
          </p>
        </div>
      </div>

      {/* Mission */}
      <div className="max-w-4xl mx-auto px-6 pb-8">
        <div className="border-l-[3px] border-blue-500 pl-6">
          <p className="text-blue-400 text-xs font-semibold tracking-[0.14em] uppercase mb-2">
            Our Mission
          </p>
          <p className="text-gray-100 text-xl leading-relaxed">
            Ensure no fan is left behind due to geography, cost, or accessibility
            barriers — while creating new revenue streams for creators and event
            organizers.
          </p>
        </div>
      </div>

      {/* What you can experience */}
      <div className="max-w-4xl mx-auto px-6 pb-24">
        <p className="text-gray-500 text-sm font-medium mb-4">
          Experience it all, live:
        </p>
        <div className="flex flex-wrap gap-3">
          {CATEGORIES.map((c) => (
            <span
              key={c}
              className="px-4 py-2 rounded-full bg-white/[0.04] border border-white/10 text-gray-200 text-sm"
            >
              {c}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
